// ─── Healthcare Job Titles for Autosuggest ───────────────────────────────────
// Used in PostJob.jsx (title field) and JobPost.jsx (search bar)

export const JOB_TITLES = [
  // ── Doctors ──────────────────────────────────────────────────────────────
  "General Physician (MBBS Doctor)",
  "Family Medicine Doctor",
  "Emergency Medicine Doctor",
  "ICU / Critical Care Specialist",
  "Cardiologist",
  "Neurologist",
  "Gastroenterologist",
  "Endocrinologist",
  "Nephrologist",
  "Pulmonologist",
  "Rheumatologist",
  "Oncologist",
  "General Surgeon",
  "Orthopedic Surgeon",
  "Neurosurgeon",
  "Cardiothoracic Surgeon",
  "Plastic & Cosmetic Surgeon",
  "Urologist",
  "Pediatrician",
  "Gynecologist / Obstetrician",
  "Dermatologist",
  "Psychiatrist",
  "Ophthalmologist (Eye Specialist)",
  "ENT Specialist",
  "Radiologist",
  "Pathologist",
  "Microbiologist",
  "Biochemist",
  "Forensic Medicine Specialist",
  "Medical Researcher",
  "Clinical Trial Doctor",
  "Medical Professor / Lecturer",
  "Tutor / Demonstrator",
  "Hospital Administrator",
  "Medical Superintendent",
  "Medical Director",
  "Clinic Owner",
  "Public Health Specialist",
  "Epidemiologist",
  "Government Medical Officer",
  "Community Medicine Doctor",
  "Medical Advisor (Pharma Company)",
  "Insurance Medical Officer",
  "Occupational Health Doctor",
  "Telemedicine Doctor",
  "Health Tech Consultant",

  // ── Dentists ─────────────────────────────────────────────────────────────
  "General Dentist (BDS)",
  "Family Dentist",
  "Cosmetic Dentist",
  "Orthodontist",
  "Dentofacial Orthopedist",
  "Oral & Maxillofacial Surgeon",
  "Dental Surgeon",
  "Endodontist",
  "Periodontist",
  "Prosthodontist",
  "Implantologist",
  "Oral Medicine Specialist",
  "Oral Radiologist",
  "Oral Pathologist",
  "Dental Lecturer / Professor",
  "Dental Researcher",
  "Hospital Dental Administrator",
  "Dental Consultant (Insurance/Corporate)",
  "Tele-Dentist",

  // ── Nurses ───────────────────────────────────────────────────────────────
  "Staff Nurse",
  "Registered Nurse (RN)",
  "Ward Nurse",
  "Bedside Nurse",
  "ICU Nurse",
  "Critical Care Nurse",
  "Emergency Room (ER) Nurse",
  "Trauma Nurse",
  "Pediatric Nurse",
  "Neonatal (NICU) Nurse",
  "Oncology Nurse",
  "Cardiac Nurse",
  "Dialysis Nurse",
  "Midwife / Nurse Midwife",
  "Maternity Nurse",
  "Labor Room Nurse",
  "Community Health Nurse",
  "Public Health Nurse",
  "Psychiatric (Mental Health) Nurse",
  "Operation Theatre (OT) Nurse",
  "Scrub Nurse",
  "Anesthesia Nurse",
  "Nursing Superintendent",
  "Nurse Educator / Tutor",
  "Nursing Administrator",
  "Home Care Nurse",
  "Telehealth Nurse",
  "Industrial Nurse",
  "Cruise Ship Nurse",

  // ── Paramedical & Lab ────────────────────────────────────────────────────
  "Medical Laboratory Technician (MLT)",
  "Medical Laboratory Technologist",
  "Phlebotomist (Blood Collection Specialist)",
  "Histopathology Technician",
  "Blood Bank Technician",
  "Radiology Technician (X-Ray)",
  "CT Scan Technician",
  "MRI Technician",
  "Ultrasound / Sonography Technician",
  "Paramedic",
  "Emergency Medical Technician (EMT)",
  "Ambulance Assistant",
  "Trauma Care Technician",
  "Nursing Assistant",
  "Ward Assistant / Ward Boy",
  "Dialysis Technician",
  "Operation Theatre (OT) Technician",
  "Physiotherapy Assistant",
  "Occupational Therapy Assistant",
  "Speech Therapy Assistant",
  "Respiratory Therapist",
  "Dental Hygienist",
  "Dental Technician",
  "Optometrist",
  "Optician",
  "Pharmacist",
  "Pharmacy Technician",
  "Clinical Pharmacist",
  "Cardiac Care Technician",
  "Anesthesia Technician",
  "Neuro Technician (EEG/EMG)",
  "Perfusionist (Heart-Lung Machine Specialist)",
];

/**
 * Returns titles that match a query string (case-insensitive, partial match).
 * @param {string} query
 * @param {number} limit  max results to return (default 8)
 * @returns {string[]}
 */
export const getSuggestions = (query, limit = 8) => {
  if (!query || query.trim().length < 1) return [];
  const q = query.toLowerCase();
  return JOB_TITLES.filter((title) =>
    title.toLowerCase().includes(q)
  ).slice(0, limit);
};